<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="x1about" id="toc_marker-1">About the Author</p>
<p class="txnoi">Cyndi Dale (Minneapolis, MN) is an internationally renowned author, speaker, healer, and business consultant. She is president of Life Systems Services, through which she has conducted over 35,000 client sessions and presented training classes throughout Europe, Asia, and the Americas. Visit her online at <span class="URL">CyndiDale.com</span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About.vue?761586d0